import * as React from 'react'
import Typography from '@mui/material/Typography'

interface Props {
  required?: boolean
  children: React.ReactElement | string
}

/**
 * ラベル
 */
export const Label: React.FC<Props> = (props) => {
  const { children, required } = props

  return (
    <Typography
      component='label'
      className={required ? 'required' : ''}
      sx={{
        color: 'rgba(0, 0, 0, 0.7)'
      }}
    >
      {children}
    </Typography>
  )
}

export default Label
